import classnames from 'classnames';
import { Tooltip, TooltipContent, TooltipTrigger } from './utils';
import { MyTooltipProps } from './types';
import IconBlack from './icon_black.svg';
import s from './index.module.scss';

export const MyTooltip = ({
  renderElement,
  renderContent,
  delay,
  theme = 'dark',
  disabled,
  elementClassName,
  elementAriaLabel,
  placement = 'top',
}: MyTooltipProps) => {
  return (
    <Tooltip disabled={disabled} placement={placement} delay={delay}>
      <TooltipTrigger className={elementClassName} aria-label={elementAriaLabel}>
        {renderElement ? (
          renderElement()
        ) : (
          <img src={IconBlack} alt="icon" width={16} height={16} />
        )}
      </TooltipTrigger>
      <TooltipContent
        arrowColor={theme === 'dark' ? '#17232D' : '#FFF'}
        className={classnames(
          s.tooltip_content,
          theme === 'dark' ? s.tooltip_content_dark : s.tooltip_content_light,
        )}
      >
        {renderContent()}
      </TooltipContent>
    </Tooltip>
  );
};
